import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { style, state, animate, transition, trigger } from '@angular/core';
import { MULTICOLOR_FULL, BLUE_FULL, DOTS_FULL, BLUE_FULL_LARGE } from './preloader-handler';
import './preloader.style.css';

@Component({
    selector: 'preloader',
    templateUrl: 'preloader.component.html'
})

export class PreloaderComponent implements OnInit {

    @Input() preloaderOpacity: string;
    @Input() preloaderText: string;
    @Input() preloaderType: string;
    public bgColor: string;
    public mcolorfull: string;
    public bluefull: string;
    public dotsfull: string;
    public dotsfulllarge: string;

    constructor() {
        this.mcolorfull = MULTICOLOR_FULL;
        this.bluefull = BLUE_FULL;
        this.dotsfull = DOTS_FULL;
        this.dotsfulllarge = BLUE_FULL_LARGE;
    }

    ngOnInit(): void {
        this.bgColor = 'rgba(245, 245, 245, ' + this.preloaderOpacity + ')';
    }

    public getPreloaderType(type: string): boolean {
        if (type == this.preloaderType) {
            return true;
        } else {
            return false;
        }
    }

}


// WEBPACK FOOTER //
// ./angularApp/app/shared/preloader/preloader.component.ts